import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsBikeNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7a3.46 3.46 0 00-.9.13L10.26 4H12a.5.5 0 01.5.5.5.5 0 001 0A1.5 1.5 0 0012 3H9.5a.5.5 0 00-.5.7l.77 1.8h-3L6.17 4H7a.5.5 0 000-1H4a.5.5 0 000 1h1.08l.86 2L5 7.34A3.5 3.5 0 106.95 11H8.5a.5.5 0 00.5-.7L7.28 6.5h3l.44 1A3.48 3.48 0 1012.5 7zm-9 6a2.5 2.5 0 11.94-4.81l-1.36 2a.5.5 0 00.42.81h2.45a2.5 2.5 0 01-2.45 2zm4.23-3H4.44l2-3zm4.77 3a2.5 2.5 0 01-1.42-4.55l1 2.25a.5.5 0 00.46.3.49.49 0 00.2 0 .5.5 0 00.26-.7l-1-2.25a2.5 2.5 0 11.5 4.95z"
  }));
});
SvgSportsBikeNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsBikeNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsBikeNormalXsmall;